import { Component, OnInit,Inject } from '@angular/core';
import { MatDialogRef} from '@angular/material';
import {RestApiService} from '../shared/restApiServices/restapi.service';
import {isUndefined} from "util";
import { TagInputModule } from 'ngx-chips';
import {MAT_DIALOG_DATA} from '@angular/material';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import 'rxjs/add/operator/filter';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/first';
import 'rxjs/add/operator/debounceTime';
import { NativeWindoRefService } from 'app/shared/services/native-windo-ref.service';
import { Router } from '@angular/router';
declare var amplitude: any;


@Component({
  selector: 'blank-survey-dialog',
  templateUrl: './blank-survey-dialog.component.html',
  styleUrls: ['./blank-survey-dialog.component.css']
})
export class BlankSurveyDialogComponent implements OnInit {

  titleValue:string;
  MastertitleValue : string;
  tagsValue:string;
  category:any;
  priLang:any;
  secondLang:any;
  titleEmpty:string;
  priEmpty:string;
  categoryEmpty:string;
  dialogTitle:string;
  noOfLang:any;
  questions = [];
  name: string;
  owner: string;
  showLoader: boolean;
  showPreview:boolean;
  formtype:boolean;
  userInput:any;
    laguageOptions= [
    {
      name:'English',value:'en'}
      ,{name:'Hindi',value:'hi'}
    // {name:'Bengali',value:'bn'},
    // ,{name:'French',value:'fr'}
    // ,{name:'German',value:'de'}
    // ,{name:'Gujarati',value:'gu'}
    // ,{name:'Kannada',value:'kn'}
    // ,{name:'Marathi',value:'mr'}
    // ,{name:'Nepali',value:'ne'}
    // ,{name:'Spanish',value:'es'}
    // ,{name:'Tamil',value:'ta'}
    // ,{name:'Telugu',value:'te'}
    // ,{name:'Urdu',value:'ur'}
  ]
  nativeWindow:any;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  public newSurveyDialogRef: MatDialogRef<BlankSurveyDialogComponent>,
  private restApiService:RestApiService, private nativeWindoRefService: NativeWindoRefService,
  private router: Router) {
    this.nativeWindow = nativeWindoRefService.getNativeWindow();
    this.category = {name:'Other',value:'4'};
    this.priLang = {name:'English',value:'en'};
    this.secondLang = {name:'Hindi',value:'hi'};
    this.noOfLang = {name:'Single',value:'Single Language'};
    this.showLoader = true;
    this.showPreview = true;
    if(this.data.questionaire_type == 0 && this.data['form_type'] == 'Master'){
      this.dialogTitle = "Standard";
      this.formtype = false;
    }
    else{
      if(this.data.form_type == "Sub"){
        this.dialogTitle = "Sub";
        this.formtype = false;
      }
      else {
        this.dialogTitle = "Grouped";
        this.formtype = true;
      }
    }
  }

  ngOnInit() {
    this.showPreview = false;
  }

  invalidForm(){
    if(this.titleValue==null || this.titleValue=="" || isUndefined(this.titleValue))
    {
      return true;
    }
    else if(this.formtype && (this.MastertitleValue==null || this.MastertitleValue=="" || isUndefined(this.MastertitleValue)))
    {
      return true;
    }
    else if(this.category==null || isUndefined(this.category.value)||this.category.value==null||this.category.value=="")
    {
      return true;
    }
    else if(this.priLang==null ||this.priLang.value==""||this.priLang.value==null||isUndefined(this.priLang))
    {
      return true;
    }
    return false;
  }

  onProceed()
  {
    if(this.titleValue==null || this.titleValue=="" || isUndefined(this.titleValue))
    {
      this.titleEmpty = "on-error";
      this.priEmpty = "";
      this.categoryEmpty = "";
    }
    else if(this.formtype && (this.MastertitleValue==null || this.MastertitleValue=="" || isUndefined(this.MastertitleValue)))
    {
      this.titleEmpty = "on-error";
      this.priEmpty = "";
      this.categoryEmpty = "";
    }
    else if(this.category==null || isUndefined(this.category.value)||this.category.value==null||this.category.value=="")
    {
      this.titleEmpty = "";
      this.priEmpty = "";
      this.categoryEmpty = "on-error";
    }
    else if(this.priLang==null ||this.priLang.value==""||this.priLang.value==null||isUndefined(this.priLang))
    {
      this.titleEmpty = "";
      this.categoryEmpty = "";
      this.priEmpty = "on-error";
    }
    else {
      if(this.noOfLang.name == "Single")
      {
        this.secondLang.value = "";
        this.secondLang.name = "";
      }
      if(!isUndefined(this.data.qnr) || this.data.qnr != null){ //mahima - useless .. this was never used for even template although was created for that
        if(this.data.questionaire_type == 1){
          this.userInput={
            surveyName:this.titleValue,
            tagsValue:this.tagsValue,
            ctg:this.category.value,
            priLang:this.priLang.value,
            secondLang:this.secondLang.value,
            type:this.data.type,
            Questionaire_type:this.data.questionaire_type,
            form_type:this.data.form_type,
            qnr:this.data.qnr,
            name:this.MastertitleValue
          };
        }
        else{
          this.userInput={
            surveyName:this.titleValue,
            tagsValue:this.tagsValue,
            ctg:this.category.value,
            priLang:this.priLang.value,
            secondLang:this.secondLang.value,
            type:this.data.type,
            Questionaire_type:this.data.questionaire_type,
            form_type:this.data.form_type,
            qnr:this.data.qnr
          };
        }
      }
      else{
        if(this.data.questionaire_type == 1){
          this.userInput={
            surveyName:this.titleValue,
            tagsValue:this.tagsValue,
            ctg:this.category.value,
            priLang:this.priLang.value,
            secondLang:this.secondLang.value,
            type:this.data.type,
            Questionaire_type:this.data.questionaire_type,
            form_type:this.data.form_type,
            parentId:this.data.parentId,
            name:this.MastertitleValue
          };
        }
        else{
          this.userInput={
            surveyName:this.titleValue,
            tagsValue:this.tagsValue,
            ctg:this.category.value,
            priLang:this.priLang.value,
            secondLang:this.secondLang.value,
            type:this.data.type,
            Questionaire_type:this.data.questionaire_type,
            form_type:this.data.form_type,
            parentId:this.data.parentId
          };
        }
      }

      let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
      this.restApiService.createQnrService(token,this.userInput).subscribe(
        result => {
          if(result.success!=false)
          {
            if(this.userInput.Questionaire_type == 1)
            {
            amplitude.getInstance().logEvent('GroupedFormsuccessfullycreated', { "Grouped Form Title": this.titleValue, "Master Form Title": this.userInput.name, "Primary Language": this.priLang.value, "Secondary Language":this.secondLang.value,"type": this.data.form_type });
            }
            else
            {
              amplitude.getInstance().logEvent('StandardFormsuccessfullycreated', { "Form Title": this.titleValue, "Primary Language": this.priLang.value, "Secondary Language":this.secondLang.value,"type": this.data.form_type });
            }
            let qId = result.result[0].qID;
            this.getQuestionnaireURL(qId);
            this.newSurveyDialogRef.close({success:true});
          }
          else {
            amplitude.getInstance().logEvent('Formnotcreated');
            console.log("fail"+result.msg);
          }

        });
    }
  }

  
  getQuestionnaireURL(qId) {
    amplitude.getInstance().logEvent('EditFormbuttonclicked');
    var currentAbsoluteUrl = this.nativeWindow.location.href;
    var currentRelativeUrl = this.router.url;
    var index = currentAbsoluteUrl.indexOf(currentRelativeUrl);
    var baseUrl = currentAbsoluteUrl.substring(0, index);
    window.open(baseUrl + '/create-questionnaire/' + qId);
  }

  onDiscard()
  {
    this.newSurveyDialogRef.close({success:false});
  }

  setLangChoice(lang)
  {
    switch (lang){
      case 'Single':
        this.noOfLang.name = "Single";
        this.noOfLang.value = "Single Language";
        break;
      case 'Multiple':
        this.noOfLang.name = "Multiple";
        this.noOfLang.value = "Double Language";
        break;
    }
  }

  setPrimaryLang(lang)
  {
    this.priLang = {value:lang.value,name:lang.name};
    // switch (lang){
    //   case 'en':
    //     this.priLang.value = "en";
    //     this.priLang.name = "English";
    //     break;
    //   case 'hi':
    //     this.priLang.value = "hi";
    //     this.priLang.name = "Hindi";
    //     break;
    // }
  }

  setSecondLang(lang)
  {
    this.secondLang = {value:lang.value,name:lang.name};
    // switch (lang){
    //   case 'en':
    //     this.secondLang.value = "en";
    //     this.secondLang.name = "English";
    //     break;
    //   case 'hi':
    //     this.secondLang.value = "en";
    //     this.secondLang.name = "Hindi";
    //     break;
    // }
  }
}



// WEBPACK FOOTER //
// ./src/app/newSurveyDialog/blank-survey-dialog.component.ts